import React, { useEffect, useState, useCallback, useRef } from "react";
import "./Siteblog.css";
import { Link } from "react-router-dom";
import {
  FaLongArrowAltRight,
  FaChevronLeft,
  FaChevronRight,
} from "react-icons/fa";
import { BASE_URL_API_TRANX_BLOG } from "../Utils/Constant";
import loaderGif from "../../src/Images/loader.gif";
import { FiSearch } from "react-icons/fi";
function Siteblog() {
  const [cards, setCards] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const scrollRef = useRef(null);

  const scroll = (direction) => {
    if (scrollRef.current) {
      const card = scrollRef.current.querySelector(".slider-card");
      if (card) {
        const cardWidth = card.getBoundingClientRect().width + 16; 
        scrollRef.current.scrollLeft +=
          direction === "left" ? -cardWidth : cardWidth;
      }
    }
  };

  const Getproductblogs = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(
        `${BASE_URL_API_TRANX_BLOG}/GetAllProductBlog`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ webid: "1" }),
        }
      );
      const data = await response.json();
      if (data.status === "0") {
        const sortedData = [...data.data].sort(
          (a, b) => new Date(b.created_at) - new Date(a.created_at)
        );
        setCards(sortedData);
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    Getproductblogs();
  }, []);

  const filteredBlogs = cards.filter((item) => {
    const lowerSearch = searchTerm.toLowerCase();
    return (
      item.title.toLowerCase().includes(lowerSearch) ||
      item.excerpt.toLowerCase().includes(lowerSearch) ||
      item.author_name.toLowerCase().includes(lowerSearch)
    );
  });

  return (
    <section className="mt-md- mt-2 mb-md-5 mb-2 ">
      <h2
        className="text-center mb-5"
        style={{
          // fontFamily: "'Playfair Display', serif",
          fontSize: "2.5rem",
        }}
      >
        Elevate Your Knowledge
      </h2>

      {isLoading && (
        <div className="d-flex justify-content-center align-items-center">
          <img src={loaderGif} alt="Loading..." />
        </div>
      )}

      <div className="slider-wrapper position-relative">
        <button className="slider-btn left" onClick={() => scroll("left")}>
          <FaChevronLeft />
        </button>

        <div className="custom-slider-container" ref={scrollRef}>
          {filteredBlogs.reverse().map((item, i) => (
            <div className="slider-card" key={i}>
              <div className="My-Landing-card">
                <img
                  src={
                    item.image_url ||
                    "https://via.placeholder.com/300x200?text=No+Image"
                  }
                  alt={item.image_alt || item.title}
                  title={item.image_title || ""}
                />
                <div className="card-content">
                  <div className="d-flex align-items-center mt-3">
                    <img
                      src={item.author_image || ""}
                      alt={item.author_name}
                      className="rounded-circle"
                      style={{
                        width: "2rem",
                        height: "2rem",
                        objectFit: "cover",
                      }}
                    />
                    <p
                      className="mx-2 mb-0"
                      style={{ fontSize: ".9rem", fontWeight: "600" }}
                    >
                      {item.author_name}
                    </p>
                  </div>
                  <h6 className="mt-2 text-truncate">{item.title}</h6>
                  <p className="excerpt">{item.excerpt}</p>
                  <div className="text-end">
                    <Link
                      to={`/blog/${item.slug}`}
                      onClick={() =>
                        sessionStorage.setItem("Slug", JSON.stringify(item))
                      }
                      className="read-more"
                    >
                      Read More <FaLongArrowAltRight />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <button className="slider-btn right" onClick={() => scroll("right")}>
          <FaChevronRight />
        </button>
      </div>
    </section>
  );
}

export default Siteblog;
